import * as React from "react";
import { Form, Approval, type BlockReceipt } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function InteractiveBlocksDemo() {
  const [formReceipt, setFormReceipt] = React.useState<BlockReceipt | undefined>(undefined);
  const [approvalReceipt, setApprovalReceipt] = React.useState<BlockReceipt | undefined>(undefined);

  return (
    <Section
      id="interactive-blocks"
      title="Form + Approval (receipt backfill)"
      description="The existing interactive blocks, backfilled with the receipt settled-state convention. When `props.receipt` is present they render the settled outcome instead of a live control - fixing the history-reload-shows-live-control bug."
    >
      <VariantBlock label="Form: live -> settled" caption="submit to settle">
        <div className="w-full max-w-md">
          <Form
            title="Request access"
            description="Tell us a bit about your use case."
            fields={[
              { name: "name", label: "Name", type: "text", required: true, placeholder: "Ada Lovelace" },
              { name: "email", label: "Work email", type: "email", required: true },
              { name: "team", label: "Team size", type: "select", placeholder: "Choose...", options: [
                { value: "1-10", label: "1-10" },
                { value: "11-50", label: "11-50" },
                { value: "50+", label: "50+" },
              ] },
              { name: "notes", label: "Notes", type: "textarea", placeholder: "Anything else?" },
              { name: "tos", label: "I agree to the terms", type: "checkbox", required: true },
            ]}
            submitLabel="Request access"
            receipt={formReceipt}
            onSubmit={(values) =>
              setFormReceipt({
                outcome: "success",
                summary: "Access requested",
                identifiers: { email: String(values.email || "-") },
                at: new Date().toISOString(),
              })
            }
          />
          {formReceipt ? (
            <button
              type="button"
              className="mt-3 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
              onClick={() => setFormReceipt(undefined)}
            >
              Reset
            </button>
          ) : null}
        </div>
      </VariantBlock>

      <VariantBlock label="Approval: live -> settled" caption="decide to settle">
        <div className="w-full max-w-md">
          <Approval
            title="Deploy to production?"
            body="This will promote **v1.4.2** from staging. Roughly 12k users are live right now."
            options={[
              { value: "approve", label: "Approve", intent: "primary" },
              { value: "later", label: "Not now", intent: "default" },
              { value: "reject", label: "Reject", intent: "danger" },
            ]}
            receipt={approvalReceipt}
            onDecide={(option) =>
              setApprovalReceipt(
                option.value === "approve"
                  ? { outcome: "success", summary: "Approved deploy of v1.4.2", at: new Date().toISOString() }
                  : option.value === "reject"
                    ? { outcome: "failed", summary: "Deploy rejected", at: new Date().toISOString() }
                    : { outcome: "cancelled", summary: "Deferred for now", at: new Date().toISOString() },
              )
            }
          />
          {approvalReceipt ? (
            <button
              type="button"
              className="mt-3 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
              onClick={() => setApprovalReceipt(undefined)}
            >
              Reset
            </button>
          ) : null}
        </div>
      </VariantBlock>

      <VariantBlock label="Pre-settled approval (history reload)">
        <div className="w-full max-w-md">
          <Approval
            title="Deploy to production?"
            options={[{ value: "approve", label: "Approve" }]}
            receipt={{ outcome: "success", summary: "Approved by you", identifiers: { release: "v1.4.1" }, at: "2026-06-19T22:05:00Z" }}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
